export default "__VITE_ASSET__DeumToLk__"